import { FC, ReactNode } from 'react'
import { Box } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { colorTokens } from '../../../shared/styles/colorTokens'
import { RADIUS } from '../../../shared/styles/radii'
import { ICON_SIZE, typeScale } from '../../../shared/styles/typography'

type CalloutProps = {
  children?: ReactNode
}

/**
 * 28 spec §4.7 警告バナー(インライン)。markdown から <Callout> として使う。
 *
 * トーンは1つだけ。「やると悪化する・間違えやすい」にのみ使い、
 * 重要度の濃淡で色を足さない (severity ladder にしない)。
 * 枠線・影・タイトルは持たない。背景と文字色だけで示す。
 */
export const Callout: FC<CalloutProps> = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      gap: 1,
      alignItems: 'flex-start',
      backgroundColor: colorTokens.state.warnBg,
      color: colorTokens.state.warnFg,
      borderRadius: `${RADIUS.md}px`,
      px: 1.5,
      py: 1,
      my: 2,
      ...typeScale.label,
    }}
  >
    <ErrorOutlineIcon
      sx={{
        fontSize: ICON_SIZE.md,
        color: colorTokens.state.warnIcon,
        flexShrink: 0,
        mt: '1px',
      }}
    />
    <Box sx={{ minWidth: 0, '& p': { m: 0, ...typeScale.label } }}>
      {children}
    </Box>
  </Box>
)
